// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_auth_auth_module_ts":"498398629649dac1","src_app_modules_order-details_order-details_module_ts":"701c0b1db5737701"}[chunkId] + ".js";
};